/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { Button as BaseButton } from '../../../components';
import withModal from '../../../lib/withModal';
import { FormattedMessage } from 'react-intl';

import CreateClientDialog from '../containers/CreateClientDialog';

const Button = styled(BaseButton)`
    width: 160px;
`;

const CreateClientButton = ({ open, onClose, onOpen }) => (
    <CreateClientDialog
        open={open}
        onClose={onClose}
        trigger={
            <Button onClick={onOpen} labelPosition="left" primary icon>
                <Icon name="add" />
                <FormattedMessage
                    id="pages.clients.CreateClientButton.addClient"
                    defaultMessage="Add Client"
                />
            </Button>
        }
    />
);

export default withModal(CreateClientButton);
